import { render, staticRenderFns } from "./ElectricityContractView.vue?vue&type=template&id=2bafd741&"
import script from "./ElectricityContractView.vue?vue&type=script&lang=ts&"
export * from "./ElectricityContractView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports